<div class="processing-bar-container">
	<div class="processing-bar leading-bar"></div>
	<div class="processing-bar trailing-bar"></div>
</div>